import React from 'react';
import { useTranslation } from 'react-i18next';
import './DeliveryQuote.css';

/**
 * DeliveryQuote — displays delivery fee + ETA or "out of range" message.
 *
 * Props:
 *   quote      — { fee, eta, currency } or null
 *   outOfRange — boolean
 *   loading    — boolean
 *   radiusKm   — max delivery radius for error message
 */
function DeliveryQuote({ quote, outOfRange, loading, radiusKm }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="delivery-quote delivery-quote--loading">
        <span className="material-icons spinning" aria-hidden="true">sync</span>
        <span>{t('deliveryQuote.calculating')}</span>
      </div>
    );
  }

  if (outOfRange) {
    return (
      <div className="delivery-quote delivery-quote--error">
        <span className="material-icons" aria-hidden="true">wrong_location</span>
        <span>{t('deliveryAddress.outsideRadius', { radius: radiusKm || '?' })}</span>
      </div>
    );
  }

  if (!quote) return null;

  return (
    <div className="delivery-quote delivery-quote--success">
      <div className="delivery-quote-row">
        <span className="material-icons" aria-hidden="true">local_shipping</span>
        <span>
          {t('deliveryQuote.fee', { fee: quote.fee, currency: quote.currency || '$' })}
        </span>
      </div>
      {quote.eta && (
        <div className="delivery-quote-row">
          <span className="material-icons" aria-hidden="true">schedule</span>
          <span>{t('deliveryQuote.eta', { minutes: quote.eta })}</span>
        </div>
      )}
    </div>
  );
}

export default DeliveryQuote;
